import { useGet } from '../../HttpClient';
import { Category } from '@app/models';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

export const pillarCode = "tms";
 
export function useCategories() {
  const get = useGet(true, pillarCode);
  const getCategories = async () => get<Category[]>(`${tenantHierarchyBaseUrl}/categories`);
  return useQueryWithErrorHandling({
    queryKey: ['categories'],
    queryFn: async () => await getCategories(),
  });
}

export function useCategoriesByType({ type }: { type: string }) {
  const get = useGet(true, pillarCode);
  const getCategories = async () => get<Category[]>(`${tenantHierarchyBaseUrl}/categories`);
  return useQueryWithErrorHandling({
    queryKey: ['categories', 'product'],
    queryFn: async () => await getCategories(),
    select: (data) => data.filter((x) => x.type.toLowerCase() === type.toLowerCase()),
  });
}
